import { Col } from '@shadcn/components/ui/col';

import { Input } from '@shadcn/components/ui/input';
import { Button } from '@shadcn/components/ui/button';


import { Label } from '@shadcn/components/ui/label';
import { useState, useEffect } from 'react';
import useProductStore from '@zustand/useProductStore';
import superagent from 'superagent';
import { backendUrl } from '../../../../helpers/consts';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shadcn/components/ui/select';
export default function ProductDetailStep({ onNext }) {
  const {
    categories,
    factoryOptions,
    addCategory,
    addFactory,
    addReportCategory,
    productName,
    reportCategories,
    subcategoryOptions,
    setSubcategoryOptions,
    setProductName,
    productNameExists,
    setProductNameExists,
    selectedCategory,
    setSelectedCategory,
    selectedFactory,
    setSelectedFactory,
    selectedReportCategory,
    setselectedReportCategory,
    subCategory,
    setSubCategory,
    selectedSubcategory,
    setSelectedSubcategory
  } = useProductStore();
  const [showNewCategory, setShowNewCategory] = useState(false);
  const [showNewFactory, setShowNewFactory] = useState(false);
  const [showNewReportCategory, setShowNewReportCategory] = useState(false);
  const [showNewSubcategory, setShowNewSubcategory] = useState(false);
  const [newCategory, setNewCategory] = useState('');
  const [newFactory, setNewFactory] = useState('');
  const [newReportCategory, setNewReportCategory] = useState('');
  const [newSubcategory, setNewSubcategory] = useState('');

  const [factoryError, setFactoryError] = useState('');
  const [categoryError, setCategoryError] = useState('');
  const [reportCategoryError, setReportCategoryError] = useState('');
  const [subcategoryError, setSubcategoryError] = useState('');
  const [productNameError, setProductNameError] = useState('');
  const [isCheckingProductName, setIsCheckingProductName] = useState(false);
  useEffect(() => {
    superagent.get(`${backendUrl}/dropdown/subcategory`)
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .then(response => {
        if(response.status < 400) {
          setSubcategoryOptions(response.body);
        }
      })
      .catch(err => {
        console.error("Error fetching subcategories:", err);
      });
  }, [setSubcategoryOptions]);


  const checkProductNameExists = async (name) => {
    if (!name || name.trim().length < 2) {
      setProductNameError('');
      setProductNameExists(false);
      return;
    }

    setIsCheckingProductName(true);
    setProductNameError('');

    try {
      const response = await superagent
        .post(`${backendUrl}/product/check-product-name`)
        .send({ name: name.trim() })
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json');

      if (response.status < 400) {
        const exists = response.body.exists;
        setProductNameExists(exists);

        if (exists) {
          setProductNameError('Product name already exists');
        } else {
          setProductNameError('');
        }
      }
    } catch (error) {
      console.error('Error checking product name:', error);
      setProductNameError('Error checking product name');
    } finally {
      setIsCheckingProductName(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (productName) {
        checkProductNameExists(productName);
      }
    }, 800);

    return () => clearTimeout(timer);
  }, [productName]);

  const handleSaveCategory = () => {
    if (!newCategory) return;

    const existingCategory = categories.find(category =>
      category.name.toLowerCase().trim() === newCategory.toLowerCase().trim()
    );

    if (existingCategory) {
      setCategoryError('Category already exists');
      return;
    }

    setCategoryError('');
    superagent.post(`${backendUrl}/product/productCategory`)
      .send({ name: newCategory })
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .then(response => {
        if(response.status > 400){

        } else {
          addCategory(response.body);
          setSelectedCategory({id: response.body._id, name: response.body.name, label: response.body.name});
          setShowNewCategory(false);
          setNewCategory('');
        }
      });
  };

  const handleSaveReportCategory = () => {
    if (!newReportCategory) return;

    const existingReportCategory = reportCategories.find(category =>
      category.name.toLowerCase().trim() === newReportCategory.toLowerCase().trim()
    );

    if (existingReportCategory) {
      setReportCategoryError('Report category already exists');
      return;
    }

    setReportCategoryError('');
    superagent.post(`${backendUrl}/product/productCategory`)
      .send({ name: newReportCategory, type: 'excel' })
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .then(response => {
        if(response.status > 400){

        } else {
          addReportCategory(response.body);
          setselectedReportCategory({id: response.body._id, name: response.body.name, label: response.body.name});
          setShowNewReportCategory(false);
          setNewReportCategory('');
        }
      });
  };

  const handleSaveSubcategory = () => {
    if (!newSubcategory) return;

    const existingSubcategory = subcategoryOptions.find(subcategory =>
      subcategory.label.toLowerCase().trim() === newSubcategory.toLowerCase().trim()
    );

    if (existingSubcategory) {
      setSubcategoryError('Subcategory already exists');
      return;
    }

    setSubcategoryError('');
    superagent.post(`${backendUrl}/dropdown/subcategory`)
      .send({ value: newSubcategory, label: newSubcategory })
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .then(response => {
        if(response.status > 400){

        } else {
          superagent.get(`${backendUrl}/dropdown/subcategory`)
            .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
            .set('accept', 'json')
            .then(fetchResponse => {
              if(fetchResponse.status < 400) {
                setSubcategoryOptions(fetchResponse.body);

                setTimeout(() => {
                  setSelectedSubcategory(response.body);
                  setSubCategory(response.body.value);
                }, 100);

                setShowNewSubcategory(false);
                setNewSubcategory('');
              }
            });
        }
      });
  };



  const handleSaveFactory = () => {
    if (!newFactory) return;

    const existingFactory = factoryOptions.find(factory =>
      factory.name.toLowerCase().trim() === newFactory.toLowerCase().trim()
    );

    if (existingFactory) {
      setFactoryError('Factory already exists');
      return;
    }

    setFactoryError('');
    superagent.post(`${backendUrl}/product/productFactory`)
      .send({ name: newFactory })
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .then(response => {
        if(response.status > 400){

        } else {
          addFactory(response.body);
          setSelectedFactory({id: response.body._id, name: response.body.name, label: response.body.name});
          setShowNewFactory(false);
          setNewFactory('');
        }
      });
  };

  
  return (
    <Col className="space-y-4 md:space-y-6 p-4 md:p-6">
      <div className="space-y-2">
        <Label htmlFor="productName">Product Name</Label>
        <div className="relative">
          <Input
            id="productName"
            value={productName}
            onChange={(e) => {
              setProductName(e.target.value);
              setProductNameError('');
            }}
            placeholder="Enter product name"
            className={`w-full ${productNameError ? 'border-red-500' : ''}`}
          />
          {isCheckingProductName && (
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
            </div>
          )}
        </div>
        {productNameError && (
          <p className="text-red-500 text-sm">{productNameError}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label>Factory</Label>
        {!showNewFactory ? (
          <div className="flex flex-col sm:flex-row gap-2">
            <Select
              key={`factory-${factoryOptions.length}`}
              value={selectedFactory?.id || ''}
              onValueChange={(value) => {
                const selectedOption = factoryOptions.find(factory => factory._id === value);
                if (selectedOption) {
                  setSelectedFactory({id: selectedOption._id, name: selectedOption.name, label: selectedOption.name});
                }
              }}
            >
              <SelectTrigger className="flex-1">
                <SelectValue placeholder="Select Factory" />
              </SelectTrigger>
              <SelectContent className="max-h-[200px] overflow-y-auto z-[99999]" position="popper" sideOffset={4}>
                {factoryOptions.map((factory) => (
                  <SelectItem key={factory._id} value={factory._id}>
                    {factory.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Button 
              variant="outline"
              onClick={() => setShowNewFactory(true)}
            >
              Add New
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <Input
              value={newFactory}
              onChange={(e) => {
                setNewFactory(e.target.value);
                setFactoryError(''); // Clear error when typing
              }}
              placeholder="Enter factory name"
              className={factoryError ? 'border-red-500' : ''}
            />
            {factoryError && (
              <p className="text-red-500 text-sm">{factoryError}</p>
            )}
            <div className="flex flex-col sm:flex-row gap-2">
              <Button
                variant="outline"
                onClick={() => {
                  setShowNewFactory(false);
                  setFactoryError('');
                }}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button
                className="flex-1"
                onClick={handleSaveFactory}
              >
                Save
              </Button>
            </div>
          </div>
        )}
      </div>


      <div className="space-y-2">
        <Label>Category</Label>
        {!showNewCategory ? (
          <div className="flex flex-col sm:flex-row gap-2">
            <Select
              key={`category-${categories.length}`}
              value={selectedCategory?.id || ''}
              onValueChange={(value) => {
                const selectedOption = categories.find(category => category._id === value);
                if (selectedOption) {
                  setSelectedCategory({id: selectedOption._id, name: selectedOption.name, label: selectedOption.name});
                }
              }}
            >
              <SelectTrigger className="flex-1">
                <SelectValue placeholder="Select Category" />
              </SelectTrigger>
              <SelectContent className="max-h-[200px] overflow-y-auto z-[99999]" position="popper" sideOffset={4}>
                {categories.map((category) => (
                  <SelectItem key={category._id} value={category._id}>
                    {category.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Button 
              variant="outline"
              onClick={() => setShowNewCategory(true)}
            >
              Add New
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <Input
              value={newCategory}
              onChange={(e) => {
                setNewCategory(e.target.value);
                setCategoryError(''); // Clear error when typing
              }}
              placeholder="Enter new category name"
              className={categoryError ? 'border-red-500' : ''}
            />
            {categoryError && (
              <p className="text-red-500 text-sm">{categoryError}</p>
            )}
            <div className="flex flex-col sm:flex-row gap-2">
              <Button
                variant="outline"
                onClick={() => {
                  setShowNewCategory(false);
                  setCategoryError('');
                }}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button
                className="flex-1"
                onClick={handleSaveCategory}
              >
                Save
              </Button>
            </div>
          </div>
        )}
        
      </div>

      <div className="space-y-2">
        <Label>Report Category</Label>
        {!showNewReportCategory ? (
          <div className="flex flex-col sm:flex-row gap-2">
            <Select
              key={`report-category-${reportCategories.length}`}
              value={selectedReportCategory?.id || ''}
              onValueChange={(value) => {
                const selectedOption = reportCategories.find(category => category._id === value);
                if (selectedOption) {
                  setselectedReportCategory({id: selectedOption._id, name: selectedOption.name, label: selectedOption.name});
                }
              }}
            >
              <SelectTrigger className="flex-1">
                <SelectValue placeholder="Select Report Category" />
              </SelectTrigger>
              <SelectContent className="max-h-[200px] overflow-y-auto z-[99999]" position="popper" sideOffset={4}>
                {reportCategories.map((category) => (
                  <SelectItem key={category._id} value={category._id}>
                    {category.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Button 
              variant="outline"
              onClick={() => setShowNewReportCategory(true)}
            >
              Add New
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <Input
              value={newReportCategory}
              onChange={(e) => {
                setNewReportCategory(e.target.value);
                setReportCategoryError(''); // Clear error when typing
              }}
              placeholder="Enter new report category name"
              className={reportCategoryError ? 'border-red-500' : ''}
            />
            {reportCategoryError && (
              <p className="text-red-500 text-sm">{reportCategoryError}</p>
            )}
            <div className="flex flex-col sm:flex-row gap-2">
              <Button
                variant="outline"
                onClick={() => {
                  setShowNewReportCategory(false);
                  setReportCategoryError('');
                }}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button
                className="flex-1"
                onClick={handleSaveReportCategory}
              >
                Save
              </Button>
            </div>
          </div>
        )}
      </div>

      <div className="space-y-2">
        <Label>Sub Category</Label>
        {!showNewSubcategory ? (
          <div className="flex flex-col sm:flex-row gap-2">
            <Select
              key={`subcategory-${subcategoryOptions.length}-${selectedSubcategory?.value || 'none'}`}
              value={selectedSubcategory?.value || ''}
              onValueChange={(value) => {
                const selectedOption = subcategoryOptions.find(option => option.value === value);
                setSelectedSubcategory(selectedOption);
                setSubCategory(value); // Keep backward compatibility
              }}
            >
              <SelectTrigger className="flex-1">
                <SelectValue placeholder="Select Sub Category" />
              </SelectTrigger>
              <SelectContent className="max-h-[200px] overflow-y-auto z-[99999]" position="popper" sideOffset={4}>
                {subcategoryOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            
            <Button 
              variant="outline"
              onClick={() => setShowNewSubcategory(true)}
            >
              Add New
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <Input
              value={newSubcategory}
              onChange={(e) => {
                setNewSubcategory(e.target.value);
                setSubcategoryError(''); // Clear error when typing
              }}
              placeholder="Enter new subcategory name"
              className={subcategoryError ? 'border-red-500' : ''}
            />
            {subcategoryError && (
              <p className="text-red-500 text-sm">{subcategoryError}</p>
            )}
            <div className="flex flex-col sm:flex-row gap-2">
              <Button
                variant="outline"
                onClick={() => {
                  setShowNewSubcategory(false);
                  setSubcategoryError('');
                }}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button
                className="flex-1"
                onClick={handleSaveSubcategory}
              >
                Save
              </Button>
            </div>
          </div>
        )}
      </div>



      

    </Col>
  );
}
